<div class="agpr-data-connector">
  <header>
    <h1 class="agpr-data-connector-heading">{{ 'DataConnector.existingDataConnections' | localize }}</h1>
    <div class="agpr-data-connector-subline">
      <p>
        {{ 'DataConnector.connectionsSubHeadingParagraph' | localize }}
      </p>
      <agpr-button
        [id]="'dataConnectors_header_newConnection'"
        class="agpr-data-connector-subline-newConnection"
        icon="fa-regular fa-duotone fa-square-plus"
        tooltip="DataConnector.newDataConnection.add"
        [style]="buttonTypesEnum.icon"
        (click)="openNewConnectionDialog()"
      >
      </agpr-button>
    </div>
  </header>
  <div class="agpr-data-connector-mainContent">
    <agpr-message
      *ngIf="!isLoadingDataConnectors && !connections?.length"
      [severity]="messageSeverityEnum.noContent"
      class="agpr-data-connector-mainContent-noConnections"
    >
      {{ 'DataConnector.noConnections' | localize }}
    </agpr-message>
    <div
      *ngIf="isLoadingDataConnectors"
      class="agpr-data-connector-loadingConnectors"
      [agprLoading]="isLoadingDataConnectors"
    >
    </div>
    <agpr-scroll-panel *ngIf="connections?.length > 0" class="agpr-data-connector-connectionsList">
      <ol id="dataConnectors" *ngIf="!isLoadingDataConnectors" agprListKeyboardNavigation [list]="connections">
        <ng-container *ngFor="let connection of connections; index as i">
          <li
            [id]="'dataConnector.connection_' + i"
            class="agpr-data-connector-connectionContainer agpr-contextMenu-parent"
            [attr.aria-label]="'DataConnector.existingDataConnections.card' | localize: {name: connection.name}"
            [agprLoading]="connection.loading"
            [agprTooltip]="connection.loading ? 'DataConnector.emailAccountReAuthenticationInProgress' : null"
          >
            <div
              class="agpr-contextMenu right bottom"
            >
                @if (connection.type === connectionTypes.EMAIL_ACCOUNT && connection?.emailAccountConnector?.grant?.requiresReAuthentication) {
                    <agpr-button
                        [id]="'dataConnector.connection_' + i + '_reauthButton'"
                        class="contextMenu"
                        (click)="reauthenticateConnection(connection)"
                        icon="fa-regular fa-duotone fa-up-right-from-square"
                        [tooltip]="'DataConnector.emailAccount.reauth.message' | localize"
                        tooltipPosition="top"
                        [style]="buttonTypesEnum.contextMenu"
                    ></agpr-button>
                } @else {
                    <agpr-button
                        [id]="'dataConnector.connection_' + i + '_editButton'"
                        class="contextMenu"
                        (click)="editConnection(connection)"
                        icon="fa-regular fa-duotone fa-pen"
                        tooltip="DataConnector.contextMenu.edit"
                        tooltipPosition="top"
                        [style]="buttonTypesEnum.contextMenu"
                    ></agpr-button>
                }
              <agpr-button
                [id]="'dataConnector.connection_' + i + '_deleteButton'"
                class="contextMenu"
                icon="fa-regular fa-duotone fa-trash-can"
                (click)="deleteConnection(connection)"
                tooltip="DataConnector.contextMenu.delete"
                tooltipPosition="top"
                 [style]="buttonTypesEnum.contextMenu"
              ></agpr-button>
            </div>
            <section class="agpr-data-connector-connectionLeft">
              @if (connection.icon) {
                <span
                    role="img"
                    class="agpr-data-connector-connectionIcon"
                    [ngClass]="connection.icon"
                ></span>
              }
              @else {
                <img class="agpr-data-connector-connectionIcon" [src]="appBaseHref + connectionTypeToIcon[connection.type]" alt="" aria-hidden="true"/>
              }
              <div class="agpr-data-connector-connectionInfo">
                <div>
                  <div class="agpr-data-connector-connectionName">{{ connection.name }}</div>
                  <div class="agpr-data-connector-connectionType">{{ connectionTypeToLocalizationKey[connection.type] | localize }}</div>
                </div>
              </div>

            </section>
            <section class="agpr-data-connector-connectionRight">
              <div
                *ngIf="connection.type !== connectionTypes.GOOGLE_ANALYTICS && connection.type !== connectionTypes.GOOGLE_ANALYTICS_4"
                class="agpr-data-connector-connectionRight-content"
              >
                <!-- TODO Update with proper values when social connections available
                <img
                  [src]="connection.account.profileImgUrl ? connection.account.profilePicture : socialConnectionPlaceholderImage[connection.type]"
                  class="agpr-data-connector-connection-profileImg"
                  [alt]="connection.account.name"
                />
                <div class="agpr-data-connector-connection-socialInfo">
                  <div class="agpr-data-connector-connection-profileName">{{ connection.account.name }}</div>
                  <a class="agpr-data-connector-connection-handle" [href]="connection.account.handleUrl">{{ connection.account.handle }}</a>
                </div> -->
              </div>

              <div class="agpr-data-connector-connectionRight-content">
                <span>{{ connection.email }}</span>
              </div>
              @if(connection.privacyLevel) {
                <div class="agpr-data-connector-connectionRight-content">
                  <span>{{ ('DataConnector.emailAccount.' + connection.privacyLevel) | localize }}</span>
                </div>
              }
              <div class="agpr-data-connector-connectionRight-content">
                <span>{{ connection.createdDate | date: dateFormat }}</span>
              </div>
              @if (connection.type === connectionTypes.EMAIL_ACCOUNT && connection?.emailAccountConnector?.grant?.requiresReAuthentication) {
                <div class="agpr-data-connector-connectionRight-error">
                    <span class="agpr-data-connector-connectionRight-error agpr-data-connector-connectionRight-error-icon agpr-message-icon fa-regular fa-minus-circle"></span>
                    <span>{{ 'DataConnector.emailAccount.reauth.message' | localize }}</span>
                </div>
              }

            </section>

          </li>
        </ng-container>
      </ol>
    </agpr-scroll-panel>
  </div>
  <agpr-action-bar>
    <ng-template #right>
      <agpr-button
        [id]="'dataConnectors_footer_newConnection'"
        class="agpr-data-connector-footer-newConnection"
        label="DataConnector.newDataConnection"
        [style]="buttonTypesEnum.primary"
        (click)="openNewConnectionDialog()"
      >
      </agpr-button>
    </ng-template>
  </agpr-action-bar>
</div>
